let title = 'PriSmart';
if (window.__POWERED_BY_QIANKUN__) {
    title = 'All-Star';
}
module.exports = {
    title,

    /**
   * @type {boolean} true | false
   * @description Whether show the settings right-panel
   */
    showSettings: false,

    /**
   * @type {boolean} true | false
   * @description Whether need tagsView
   */
    tagsView: false,

    /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
    fixedHeader: false,

    /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
    sidebarLogo: true,

    /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
    errorLog: 'development'
};
